export default class CredentialStore {
    constructor(actualStore) {
        this.actualStore = actualStore;
    }

    changeEnvironment(newEnvironment) {
        this.actualStore.changeEnvironment(newEnvironment);
    }

    setLastUsedEnvironment() {
        this.actualStore.setLastUsedEnvironment();
    }

    getEnvironment() {
        return this.actualStore.environment;
    }

    setTokens(accessToken, refreshToken) {
        this.actualStore.set('accessToken', accessToken);
        this.actualStore.set('refreshToken', refreshToken);
    }

    getTokens() {
        return {
            accessToken: this.actualStore.get('accessToken'),
            refreshToken: this.actualStore.get('refreshToken'),
        };
    }

    deleteTokens() {
        this.actualStore.deleteStore();
    }
}
